<template>
  <page>
    <template slot="title">Личный кабинет</template>
    <template slot="section">
      <columns>
        <column size="6">
          <column size="9">
            <div class="form">
              <p>Добро пожаловать в личный кабинет абонента! Введите регистрационные данные в форму ниже.</p>
            </div>
            <p style="font-size: 16px;">данные для авторизации можно найти в договоре, для получения
            дополнительной информации обратитесь по телефону <a style="font-size: 12px;" href="tel:84957739215">8&nbsp;(495)&nbsp;773-92-15</a></p>
          </column>
        </column>
        <column size="4">
          <div class="form">
            <form name="login" action="/login" method="post" @submit="submitForm">
              <input v-model="login" placeholder="Логин" @focus="focusInput">
              <input v-model="password" placeholder="Пароль" @focus="focusInput">
              <button
                type="submit"
                :class="[ errors.submit ? 'invalid' : '' ]"
                :disabled="!(login && password)"
              >
                Войти
              </button>
              <label v-if="errors.submit">{{ errors.submit }}</label>
            </form>
          </div>
        </column>
      </columns>
    </template>
    <template slot="aside">
      <aside-image :image="imageBg"/>
    </template>
  </page>
</template>

<script>
import imageBg from '../../static/i/img-16.jpg';

import Columns from '@/components/columns/Columns';
import Column from '@/components/columns/Column';
import Page from '@/components/Page';
import AsideImage from '@/components/AsideImage';

export default {
  components: {
    Columns,
    Column,
    Page,
    AsideImage,
  },
  data: () => {
    return {
      imageBg: imageBg,
      errors: {},
      login: null,
      password: null,
    }
  },
  methods: {
    submitForm: function(e) {
      this.errors = {};
      if (!this.login) {
        this.errors.login = 'Укажите имя пользователя';
      }
      if (!this.password) {
        this.errors.password = 'Укажите пароль';
      }
      this.errors.submit = 'Пользователь не найден';
      e.preventDefault();
    },
    focusInput: function() {
      this.errors = {};
    }
  }
}
</script>

<style lang="scss">
.form {
  input {
    border: 2px solid #e8e8e8;
    border-radius: 10px;
    font-size: 20px;
    text-align: center;
    line-height: 46px;
    padding: 0;
    width: 100%;
    margin: 0 0 25px;
    outline: none;
    background: #e8e8e8;
    transition: background .3s ease;
    cursor: pointer;
    &:focus {
      background: transparent;
    }
  }
  button {
    border: 2px solid #9CE2A4;
    border-radius: 10px;
    font-size: 20px;
    text-align: center;
    line-height: 46px;
    padding: 0;
    width: 100%;
    margin: 0 0 25px;
    outline: none;
    background: #9CE2A4;
    cursor: pointer;
    &[disabled="disabled"] {
      cursor: default;
      opacity: .4;
    }
    &.invalid {
      animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
      transform: translate3d(0, 0, 0);
      backface-visibility: hidden;
      perspective: 1000px;
    }
  }
  label {
    font-size: 14px;
  }

  @keyframes shake {
    10%, 90% {
      transform: translate3d(-1px, 0, 0);
    }
    20%, 80% {
      transform: translate3d(2px, 0, 0);
    }
    30%, 50%, 70% {
      transform: translate3d(-4px, 0, 0);
    }
    40%, 60% {
      transform: translate3d(4px, 0, 0);
    }
  }
}
</style>



// WEBPACK FOOTER //
// Profile.vue?641d4bf4